import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/navigation/Header';
import CertificateCard from './components/CertificateCard';
import VerificationBadge from './components/VerificationBadge';
import CompanyInformation from './components/CompanyInformation';
import TwoFactorAuth from './components/TwoFactorAuth';

const TrustAndSecurity = () => {
  const certificates = [
  {
    id: 'iso-27001',
    name: 'ISO/IEC 27001:2022',
    type: 'Informasjonssikkerhetsstyring',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14040ecbb-1772184386051.png",
    logoAlt: 'ISO 27001 certification badge with blue and white geometric design showing information security management standard',
    issuingAuthority: 'Det Norske Veritas (DNV)',
    coverageScope: 'Omfatter alle aspekter av informasjonssikkerhetsstyring inkludert:\n• Databeskyttelse og personvern\n• Nettverkssikkerhet og infrastruktur\n• Tilgangskontroll og autentisering\n• Hendelseshåndtering og kontinuitet',
    certificateNumber: 'NO-2025-ISO27001-8472',
    issuedDate: '2025-01-15',
    validUntil: '2028-01-14',
    renewalDate: '2027-10-15'
  },
  {
    id: 'gdpr-cert',
    name: 'GDPR Compliance Certificate',
    type: 'Personvernforordningen',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef5016ca-1772184387597.png",
    logoAlt: 'GDPR compliance certificate emblem with European Union stars and data protection shield symbol',
    issuingAuthority: 'Datatilsynet (Norwegian Data Protection Authority)',
    coverageScope: 'Fullstendig overholdelse av GDPR-krav:\n• Behandling av personopplysninger\n• Brukerrettigheter og samtykke\n• Dataportabilitet og sletting\n• Sikkerhetstiltak og risikovurdering',
    certificateNumber: 'GDPR-NO-2025-3891',
    issuedDate: '2025-05-15',
    validUntil: '2026-05-14',
    renewalDate: '2026-02-15'
  },
  {
    id: 'pci-dss',
    name: 'PCI DSS Level 1',
    type: 'Betalingskortindustri datasikkerhet',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_197473356-1772184388041.png",
    logoAlt: 'PCI DSS Level 1 certification logo with credit card security shield and payment industry standards emblem',
    issuingAuthority: 'PCI Security Standards Council',
    coverageScope: 'Høyeste nivå av betalingssikkerhet:\n• Sikker behandling av kortdata\n• Kryptert dataoverføring\n• Regelmessige sikkerhetstester\n• Streng tilgangskontroll',
    certificateNumber: 'PCI-DSS-L1-NO-2025-6742',
    issuedDate: '2025-03-10',
    validUntil: '2026-03-09',
    renewalDate: '2025-12-10'
  },
  {
    id: 'iso-9001',
    name: 'ISO 9001:2015',
    type: 'Kvalitetsstyringssystem',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d24ba89f-1772184388585.png",
    logoAlt: 'ISO 9001 quality management certification badge with circular design and quality assurance symbols',
    issuingAuthority: 'Bureau Veritas Norway',
    coverageScope: 'Kvalitetsstyring på tvers av alle tjenester:\n• Kundetilfredshet og service\n• Kontinuerlig forbedring\n• Prosessstyring og dokumentasjon\n• Leverandørstyring',
    certificateNumber: 'ISO9001-BV-NO-2025-1923',
    issuedDate: '2025-02-20',
    validUntil: '2028-02-19',
    renewalDate: '2027-11-20'
  }];


  return (
    <>
      <Helmet>
        <title>Tillit og sikkerhet - Veiassistent</title>
        <meta
          name="description"
          content="Veiassistent er en verifisert norsk tjeneste med ISO-sertifiseringer, GDPR-overholdelse og høyeste sikkerhetsstandarder for veitjenester i Norge." />
        
      </Helmet>
      <Header />
      <main className="min-h-screen bg-background pt-[84px] pb-16 md:pb-24">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8">
          <div className="mb-8 md:mb-12">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-heading mb-4">
              Tillit og sikkerhet
            </h1>
            <p className="text-base md:text-lg text-muted-foreground font-body max-w-3xl">
              Vi tar sikkerhet og personvern på alvor. Veiassistent er sertifisert og verifisert i henhold til de høyeste norske og internasjonale standardene.
            </p>
          </div>

          <div className="mb-8 md:mb-12">
            <VerificationBadge />
          </div>

          <div className="mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground font-heading mb-6">
              Sikkerhetssertifiseringer
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
              {certificates?.map((certificate) =>
              <CertificateCard key={certificate?.id} certificate={certificate} />
              )}
            </div>
          </div>

          <CompanyInformation />

          <div className="mt-8 md:mt-12">
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground font-heading mb-6">
              Kontosikkerhet
            </h2>
            <TwoFactorAuth />
          </div>
        </div>
      </main>
    </>);

};

export default TrustAndSecurity;